import { defineMessages } from 'react-intl'

export const offerTypeTitleMessages = defineMessages({
  cruises: {
    id: 'Oxjkf_auVs15_dWac_Y0',
    defaultMessage: 'Cruises',
    description: 'Title label for the cruises offer type in the localised offer types list display',
  },
  homesAndVillas: {
    id: '-Atrwzu3_j--mQ2JIDMf',
    defaultMessage: 'Homes & Villas',
    description: 'Offer type title for homes and villas on the villa or rental property page',
  },
  experiences: {
    id: 'W3h42tf8zuZwxfONuafz',
    defaultMessage: 'Experiences',
    description: 'Offer type title for experiences on the experience offer or booking page',
  },
  flights: {
    id: 'ep6bplwWi4B0hsT7ZLqd',
    defaultMessage: 'Flights',
    description: 'Title label for the flights offer type in the localised offer types list display',
  },
  carHire: {
    id: 'jM3c5eS3RS8io2BEe93X',
    defaultMessage: 'Car Hire',
    description: 'Title label for the car hire offer type in the localised offer types list display',
  },
})

export const offerTypeDescriptionMessages = defineMessages({
  hotels: {
    id: 'c6u04c71dxl7ZWjXKrIR',
    defaultMessage: 'The best hotels and resorts in the world',
    description: 'Offer type description for hotels on the hotel or room booking page',
  },
  tours: {
    id: '_2Zb8fHVE24pMXlik_6g',
    defaultMessage: 'Tours that do all the hard work for you',
    description: 'Offer type description for tours on the tour offer detail page',
  },
  cruises: {
    id: 'anZjFspIz7SyoM7a2hrW',
    defaultMessage: 'Thousands of itineraries all around the world',
    description: 'Offer type description for cruises in the cruise offer or booking section',
  },
  ultraLux: {
    id: 'SfSnXMfoSmjlWsjGYLrY',
    defaultMessage: 'Experience the world’s most luxurious hotels, tours & cruises',
    description: 'Offer type description for ultra lux in the cruise offer or booking section',
  },
  homesAndVillas: {
    id: 'BpAQ5EPZGTaVwvdU74Fa',
    defaultMessage: 'Entire properties for the ultimate escape',
    description: 'Offer type description for homes and villas on the rental page',
  },
  experiences: {
    id: 'qaujMTU7Ark_SzbLHxEW',
    defaultMessage: 'Immerse yourself in your destination',
    description: 'Offer type description for experiences on the experience offer or booking page',
  },
  flights: {
    id: 'FCqM3fXZTW3jnB62P2v-',
    defaultMessage: 'Your ticket to the world',
    description: 'Offer type description for flights in the flight search or booking flow',
  },
  carHire: {
    id: 'BrrigfncI1D4y4ndLETW',
    defaultMessage: 'Making it easy to get from A to B',
    description: 'Offer type description for car hire in the car hire booking section',
  },
})
